/**
 * GBA/ITC Gateway API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserDto { 
    /**
     * Unique user identifier
     */
    userId: string;
    /**
     * User email address
     */
    email: string;
    /**
     * User first name
     */
    firstName: string;
    /**
     * User last name
     */
    lastName: string;
    /**
     * Gateway user role (admin, operator, viewer)
     */
    role: UserDto.RoleEnum;
    /**
     * Whether the user account is active
     */
    isActive: boolean;
    /**
     * Last login timestamp (UTC)
     */
    lastLoginUtc?: string;
    /**
     * Account creation timestamp (UTC)
     */
    createdAt: string;
    /**
     * Account last update timestamp (UTC)
     */
    updatedAt: string;
}
export namespace UserDto {
    export const RoleEnum = {
        Admin: 'admin',
        Operator: 'operator',
        Viewer: 'viewer'
    } as const;
    export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];
}


